import { Injectable } from '@angular/core';
import { InvoiceData } from '../_models/invoicedata';
import { Observable } from 'rxjs';
import { HttpParams } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { AppService } from '../appservice.service';

@Injectable({
  providedIn: 'root'
})
export class InvoicelistService {

  constructor(private service: AppService) { }
  totallen = 0;

  findInvoices(filter = '', sortOrder = 'asc',
    pageNumber = 0, pageSize = 10): Observable<InvoiceData[]> {

    return this.service.getRequest('api/invoices?' + {
      params: new HttpParams()
        .set('filter', filter)
        .set('sortOrder', sortOrder)
        .set('pageNumber', pageNumber.toString())
        .set('pageSize', pageSize.toString())
    }.params.toString()).pipe(
      map(res => {
        res['payload'] = res;
        this.totallen = (res.length * (pageNumber + 1)) + 1;
        return res['payload'];
      })
    );
  }
}
